import type { Marca } from "@mtc/ui";

/** Configuracao em RUNTIME (o ambiente entrega /config.json). O tema vem de /marca/tema.css. */
export type Config = {
  API_URL: string;
  PAGAMENTOS_URL: string;
  EMAILS_BOARD_URL?: string;
  /** local, homologacao ou producao. Em homologacao toda tela mostra a faixa "Ambiente de testes". */
  AMBIENTE?: "local" | "homologacao" | "producao";
  MARCA_NOME: string;
  LOGO_URL?: string;
  /** Logo pra fundo claro (modo dia); sem ele, o mesmo nos dois modos. */
  LOGO_CLARO_URL?: string;
  /** Commit desta imagem: vira a versao (release) dos erros no Sentry. */
  VERSAO?: string;
  /** Chave publica do Sentry (vazia: nada sai do navegador). */
  SENTRY_DSN?: string;
  SUPORTE_EMAIL?: string;
  /** Site da marca: pra onde o voltar do checkout leva quando ele nao tem back redirect (spec 045, 3.7 e 3.10). */
  LANDING_URL?: string;
};

let cache: Config | null = null;

export async function carregarConfig(): Promise<Config> {
  if (cache) return cache;
  const resp = await fetch("/config.json", { cache: "no-store" });
  if (!resp.ok) throw new Error(`config.json indisponivel (${resp.status})`);
  cache = (await resp.json()) as Config;
  document.title = `${cache.MARCA_NOME} · Painel`;
  return cache;
}

export function config(): Config {
  if (!cache) throw new Error("config ainda nao carregada");
  return cache;
}

export function marca(): Marca {
  const c = config();
  return { nome: c.MARCA_NOME, logoUrl: c.LOGO_URL || undefined, logoClaroUrl: c.LOGO_CLARO_URL || undefined, suporteEmail: c.SUPORTE_EMAIL || undefined };
}
